var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-title',{staticClass:"pt-2 pb-2"},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-wardrobe-outline")]),_vm._v(" Garderobe für Jobs (Manager) ")],1),_c('v-divider'),_c('v-card-text')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }